/// <reference path="../../lib/app.d.ts" />

import {AppState} from "../application/application";
import {RoomData} from "../lib/room";
import {Translator} from "../utils/translator";
import logging from "../utils/log";

interface ButtonParams {
	title ?: string;
	title2 ?: string;
	action : string;
	data ?: any;
	extraClass ?: string;
	tParams ?: any;
}

/**
 * Handles the stream container and everything inside it
 */
export class StateButtons
{
	TAG = "StateButtons";
	currentState: AppState;
	private creditButtonCountDown = null;
	private creditButtonCountDownEnd = null;
	private creditButtonCountDownTimer = null;
	private creditButtonAction: string;
	private currentRoom: RoomData;

	constructor(
		private $bottomPanel : JQuery,
		private $topRoot     : JQuery,
		private $bottomRoot  : JQuery,
		private translator   : Translator,
	    private isGuest      : boolean,
	    private flavour      : string      // app mode (can be full, testing, or mobile)
	)
	{
		this.showFor(null, null);

		if (this.isGuest) {
			setInterval(() => {
				this.$bottomRoot.find("[data-action=register]").addClass("sxc-animate");
				setTimeout(() => {

					this.$bottomRoot.find("[data-action=register]").removeClass("sxc-animate");
				}, 4000)
			}, 10000);
		}
	}

	/**
	 * Places this component to the specified coordinates with the specified size
	 */
	public place(x : number, y : number, w : number, h : number) : void
	{
		this.$bottomPanel.css({
			top: y,
			left: x,
			width: w,
			height: h
		});
	}

	/**
	 * Clears placement css from this component
	 */
	public clearPlace() : void
	{
		this.$bottomPanel.css({
			top: "",
			left: "",
			bottom: "",
			right: "",
			width: "",
			height: ""
		});
	}

	private getCreditButton()
	{
		const cb = this.$bottomRoot.find(".topup-button");
		return cb.length ? cb : null;
	}

	private addButton3(params : ButtonParams)
	{
		let $node = $("<div class=\"sxccb-button-wrapper\">");
		let $button = $("<button class='sxccb-button' />");

		if (params.extraClass) {
			$button.addClass(params.extraClass)
		}

		if (params.action) {
			$button.attr("data-action", params.action);
		} else {
			$button.addClass("disabled").prop("disabled", true);
		}

		$button.append(
			$("<div class='sxccb-button-inner'/>").html(
				params.title
					? this.translator.t(params.title, params.tParams)
					: ""
			)
		);

		if (params.data) {
			for (let key of Object.keys(params.data)) {
				$button.attr("data-" + key, params.data[key]);
			}
		}

		if (params.title2)
		{
			$button.append(
				$("<div class='sxccb-button-inner'/>").html(
					params.title2
						? this.translator.t(params.title2, params.tParams)
						: ""
				)
			);
			$node.addClass("sxccb-button-wrapper-replace");
			$button.addClass("sxccb-button-replace");

			$button.on("mouseenter", (e) => {

				const $elem = $(e.currentTarget);
				let removeHover, addHover;

				$elem.data("timer2", setTimeout(() => {
					if ($elem.data("mouse-is-over")) return;

					$elem.data("mouse-is-over", 1);

					removeHover = () => {
						$elem.removeClass("sxc-hover");
						if ($elem.closest('body').length > 0 && $elem.data("mouse-is-over")) {
							$elem.data("timer", setTimeout(addHover, 2500));
						}
					};

					addHover = () => {
						if ($elem.closest('body').length > 0 && $elem.data("mouse-is-over")) {
							$elem.addClass("sxc-hover");
							$elem.data("timer", setTimeout(removeHover, 2500));
						}
					};

					addHover();
				}, 500));
			});

			$button.on("mouseleave", (e) => {

				const $elem = $(e.currentTarget);

				clearTimeout($elem.data("timer"));
				clearTimeout($elem.data("timer2"));

				$elem.removeClass("sxc-hover");

				$elem.removeData("timer");
				$elem.removeData("mouse-is-over");
			});

		}

		$node
			.append($button)
			.appendTo(this.$bottomRoot);
	}

	private addButton(place : string, title, tParams, action = null, extraClass = null)
	{
		let $node = $("<div class=\"sxccb-button-wrapper\">").append(
			$("<button class='sxccb-button' />").append(
				$("<div class='sxccb-button-inner'>").html(title ? this.translator.t(title, tParams) : "")
			)
		);

		let $button = $node.find("button");

		if (action) $button.attr("data-action", action);
		else $button.addClass("disabled");

		if (extraClass) $button.addClass(extraClass);

		$node.appendTo(place == "top" ? this.$topRoot : this.$bottomRoot);
	}

	private addButton2(title1, title2, tParams, action = null, extraClass = null)
	{
		let $node = $("<div class=\"sxccb-button-wrapper sxccb-button-wrapper-flip\">").append(
			$("<button class='sxccb-button sxccb-button-flip' />").append(
				$("<div class='sxccb-button-inner'>").html(title1 ? this.translator.t(title1, tParams) : ""),
				$("<div class='sxccb-button-inner'>").html(title2 ? this.translator.t(title2, tParams) : "")
			)
		);

		let $button = $node.find("button");

		if (action) $button.attr("data-action", action);
		else $button.addClass("disabled");
		if (extraClass) $button.addClass(extraClass);

		$node.appendTo(this.$bottomRoot);
	}

	public showFor(state : AppState, room : RoomData)
	{
		this.currentState = state;
		this.currentRoom = room;
		this.reRender();
	}

	reRender()
	{
		const strike = (text) => "<span class='sxcc-strikethrough'>" + text + "</span>";

		this.$topRoot.empty();
		this.$bottomRoot.empty();

		let room = this.currentRoom;

		switch (this.currentState)
		{
			case AppState.voyeurShow:

				this.addButton3({
					title: "bottom_button_exit",
					action: "exitVoyeurShow"
				});

				break;

			case AppState.privateShow:

				this.addButton3({
					title: "bottom_button_exit",
					action: "exitPrivateShow"
				});
				break;

			case AppState.exclusiveShow:

				this.addButton3({
					title: "bottom_button_exit",
					action: "exitExclusiveShow"
				});
				break;

			case AppState.groupShow:

				/*if (!room.isExclusiveAllowed() && room.isPrivateAllowed())
				{
					let button : ButtonParams = {
						title: "bottom_button_private",
						action: "enterChatMode",
						data: {mode: "private"},
						tParams: {
							amount: room.getPrivatePrice(),
						}
					};

					if (!this.isGuest) {
						if (room.roomData.pricingInfo) {
							button.title2 = "bottom_button_price_promo";
							button.tParams.old_amount = strike(room.roomData.pricingInfo.standardPricing.private)
						} else {
							button.title2 = "bottom_button_price";
						}
					}

					this.addButton3(button);
				}

				if (room.isExclusiveAllowed())
				{
					let button : ButtonParams = {
						title: "bottom_button_exclusive",
						action: "enterChatMode",
						data: {mode: "exclusive"},
						tParams: {amount: room.getExclusivePrice()}
					};

					if (!this.isGuest) {
						if (room.roomData.pricingInfo) {
							button.title2 = "bottom_button_price_promo";
							button.tParams.old_amount = strike(room.roomData.pricingInfo.standardPricing.exclusive)
						} else {
							button.title2 = "bottom_button_price";
						}
					}

					this.addButton3(button);
				}*/

				this.addButton3({
					title: "bottom_button_group_exit",
					action: "exitGroupShow"
				});
				break;

			case AppState.groupLobby:
				if (room.isGroupAllowed())
				{
					let button : ButtonParams = {
						title: "bottom_button_group",
						action: "enterChatMode",
						data: {mode: "group"},
						tParams: {amount: room.getGroupPrice()}
					};

					if (!this.isGuest) {
						if (room.roomData.pricingInfo) {
							button.title2 = "bottom_button_price_promo";
							button.tParams.old_amount = strike(room.roomData.pricingInfo.standardPricing.group)
						} else {
							button.title2 = "bottom_button_price";
						}
					}

					this.addButton3(button);
				}
				break;

			case AppState.freeShow:

				if (!room.isExclusiveAllowed() && room.isPrivateAllowed())
				{
					let button : ButtonParams = {
						title: "bottom_button_private",
						action: "enterChatMode",
						data: {mode: "private"},
						tParams: {amount: room.getPrivatePrice()}
					};

					if (!this.isGuest) {
						if (room.roomData.pricingInfo) {
							button.title2 = "bottom_button_price_promo";
							button.tParams.old_amount = strike(room.roomData.pricingInfo.standardPricing.private)
						} else {
							button.title2 = "bottom_button_price";
						}
					}

					this.addButton3(button);
				}

				if (room.isExclusiveAllowed())
				{
					let button : ButtonParams = {
						title: "bottom_button_exclusive",
						action: "enterChatMode",
						data: {mode: "exclusive"},
						tParams: {amount: room.getExclusivePrice()}
					};

					if (!this.isGuest) {
						if (room.roomData.pricingInfo) {
							button.title2 = "bottom_button_price_promo";
							button.tParams.old_amount = strike(room.roomData.pricingInfo.standardPricing.exclusive)
						} else {
							button.title2 = "bottom_button_price";
						}
					}

					this.addButton3(button);
				}

				if (room.isGroupAllowed())
				{
					let button : ButtonParams = {
						title: "bottom_button_group",
						action: "enterChatMode",
						data: {mode: "group"},
						tParams: {amount: room.getGroupPrice()}
					};

					if (!this.isGuest) {
						if (room.roomData.pricingInfo) {
							button.title2 = "bottom_button_price_promo";
							button.tParams.old_amount = strike(room.roomData.pricingInfo.standardPricing.group)
						} else {
							button.title2 = "bottom_button_price";
						}
					}

					this.addButton3(button);
				}
				break;

			case AppState.privateLobby:

				if (room.isVoyeurAllowed())
				{
					let button : ButtonParams = {
						title: "bottom_button_voyeur",
						action: "enterChatMode",
						data: {mode: "voyeur"},
						tParams: {amount: room.getVoyeurPrice()}
					};

					if (!this.isGuest) {
						if (room.roomData.pricingInfo) {
							button.title2 = "bottom_button_price_promo";
							button.tParams.old_amount = strike(room.roomData.pricingInfo.standardPricing.voyeur)
						} else {
							button.title2 = "bottom_button_price";
						}
					}
					this.addButton3(button);
				}

				break;
		}

		let extraClass = this.$bottomRoot.is(":empty") ? "sxccb-alone" : "";

		if (this.isGuest)
		{
			this.addButton3({
				title: "bottom_button_register",
				action: "register",
				extraClass : extraClass
			});

		} else {
			this.addButton3({
				title: "bottom_button_topup",
				action: this.creditButtonAction ? this.creditButtonAction : "topup",
				extraClass: "topup-button " + extraClass
			});

			if (this.creditButtonCountDown && Date.now() < this.creditButtonCountDownEnd) {
				this.creditButtonTick();
			}
		}

		if (!this.$bottomRoot.find("button").length)
		{
			this.addButton3({
				title: "",
				action: null,
			});
		}
	}

	creditButtonTick()
	{
		const $cb = this.getCreditButton();
		if (!$cb.length) return;

		if (!this.creditButtonCountDown || Date.now() > this.creditButtonCountDownEnd) {
			logging.log(this.TAG, "CreditButton is being removed", this.creditButtonCountDown, Date.now() > this.creditButtonCountDownEnd);
			$cb.find(".sxccb-button-inner").html(this.translator.t("bottom_button_topup"));
			this.creditButtonCountDown = null;
			return;
		}

		let eta = Math.floor((this.creditButtonCountDownEnd - Date.now()) / 1000);
		let etaText;

		let s = eta % 60;
		let m = Math.floor(eta / 60);

		if (m >= 60) {
			let h = Math.floor(m / 60);
			m = m % 60;
			etaText =  (h) + ":" + (m < 10 ? "0" + m : m) +  ":" + (s < 10 ? "0" + s : s);
		} else {
			etaText =  (m) +  ":" + (s < 10 ? "0" + s : s);
		}

		$cb.find(".sxccb-button-inner").html(
			this.translator.t("bottom_button_topup_" + this.creditButtonCountDown, {time: etaText}));

		this.creditButtonCountDownTimer = setTimeout(() => this.creditButtonTick(), 1000);
	}

	creditButtonCountdown(name: string, end: number = null)
	{
		logging.log(this.TAG, "CreditButtonCountDown is set", name, end);
		if (this.creditButtonCountDownTimer) {
			clearTimeout(this.creditButtonCountDownTimer);
		}
		this.creditButtonCountDown = name;
		this.creditButtonCountDownEnd = end;
		this.creditButtonCountDownTimer = setTimeout(() => this.creditButtonTick(), 1000);
	}

	setCreditButtonAction(action: string)
	{
		this.creditButtonAction = action;
		const $cb = this.getCreditButton();
		if (!$cb.length) return;
		$cb.attr("data-action", action ? action : "topup");
	}

	shakeCreditButton()
	{
		this.getCreditButton().addClass("sxc-animate");
		setTimeout(() => {
			this.getCreditButton().removeClass("sxc-animate");
		}, 4000)
	}
}
